(function ($) {
    $(function () {
        $('.js-button-search').on('click', function () {
            $('.search-bar').addClass('search-bar-active')
            $('.ol-zoom-in, .ol-zoom-out, .ol-zoom-extent button').css('right', $('.search-bar').width() + 56 + "px")
        });

        $('.js-close-search-bar').on('click', function () {
            $('.search-bar').removeClass('search-bar-active')
            $('.ol-zoom-in, .ol-zoom-out, .ol-zoom-extent button').css('right', '24px')
            $('.logo').css('z-index', 3)
        });
    });
})(jQuery);